module.exports = __webpack_public_path__ + "img/icon-channel.f10d2c52.svg";